<template>
	<el-tabs v-model="activeName">
		<el-tab-pane label="盘库" name="op">
			<div class="content-box">
				<edit-stocktaking></edit-stocktaking>
			</div>
		</el-tab-pane>
		<el-tab-pane label="盘库记录" name="his">
			<his v-if="activeName=='his'" :type="[31,32,99]"></his>
		</el-tab-pane>
	</el-tabs>
</template>

<script>
import TabPage from "@/mixins/TabPage.js";
import His from "@/views/Inventory/subs/His.vue";
import EditStocktaking from "@/views/Inventory/subs/EditStocktaking";

export default {
	mixins: [TabPage],
	components: {
		His,
		EditStocktaking
	},
	data() {
		return {
			activeName: "op"
		};
	}
};
</script>
<style lang="scss" scoped>
</style>
